// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Lazy from "../Control.Lazy/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_LogicExpr_AST from "../Data.LogicExpr.AST/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_Expr from "../Parsing.Expr/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
import * as Parsing_String_Basic from "../Parsing.String.Basic/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_String_Regex_Flags.monoidRegexFlags);
var alt = /* #__PURE__ */ Control_Alt.alt(Parsing.altParserT);
var applyFirst = /* #__PURE__ */ Control_Apply.applyFirst(Parsing.applyParserT);
var voidLeft = /* #__PURE__ */ Data_Functor.voidLeft(Parsing.functorParserT);
var map = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_LogicExpr_AST.applicativeExpr);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Parsing.applyParserT);
var fix = /* #__PURE__ */ Control_Lazy.fix(Parsing.lazyParserT);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var unsafeRegex = function (d) {
    return function (f) {
        return Data_Either.either(Partial_Unsafe.unsafeCrashWith)(identity)(Parsing_String.regex(d)(f));
    };
};
var unsafeRegexToken = function (d) {
    return unsafeRegex("\\s*(?:" + (d + ")\\s*"))(Data_String_Regex_Flags.multiline);
};
var termLexemes = {
    base64: /* #__PURE__ */ unsafeRegex("(?:[a-zA-Z0-9+/]{4})*(?:(?:[a-zA-Z0-9+/]{4})|(?:[a-zA-Z0-9+/]{3}=)|(?:[a-zA-Z0-9+/]{2}==))")(mempty),
    urlSafeBase64: /* #__PURE__ */ unsafeRegex("(?:[a-zA-Z0-9-_]{4})*(?:(?:[a-zA-Z0-9-_]{4})|(?:[a-zA-Z0-9-_]{3})|(?:[a-zA-Z0-9-_]{2}))")(mempty)
};
var termChar = /* #__PURE__ */ alt(Parsing_String_Basic.alphaNum)(/* #__PURE__ */ Parsing_String_Basic.oneOf([ "-", "_", "+", "/" ]));
var urlSafeBase64 = /* #__PURE__ */ (function () {
    return Parsing_Combinators.withErrorMessage(applyFirst(termLexemes.urlSafeBase64)(Parsing_Combinators.notFollowedBy(termChar)))("URLSafeBase64-Term");
})();
var parens = function (p) {
    var rparens = unsafeRegexToken("\\)");
    var lparens = unsafeRegexToken("\\(");
    return Parsing_Combinators.between(lparens)(rparens)(p);
};
var operatorTable$prime = function (lex) {
    return [ [ new Parsing_Expr.Prefix(voidLeft(lex.neg)(Data_LogicExpr_AST.Neg.create)) ], [ new Parsing_Expr.Infix(voidLeft(lex.conj)(Data_LogicExpr_AST.And.create), Parsing_Expr.AssocRight.value) ], [ new Parsing_Expr.Infix(voidLeft(lex.disj)(Data_LogicExpr_AST.Or.create), Parsing_Expr.AssocRight.value) ], [ new Parsing_Expr.Infix(voidLeft(lex.implies)(Data_LogicExpr_AST.Implies.create), Parsing_Expr.AssocRight.value) ], [ new Parsing_Expr.Infix(voidLeft(lex.equiv)(Data_LogicExpr_AST.Equiv.create), Parsing_Expr.AssocRight.value) ] ];
};
var exprLexemes = {
    neg: /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ unsafeRegexToken("!|~"))("negation"),
    conj: /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ unsafeRegexToken("&+"))("conjunction (AND)"),
    disj: /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ unsafeRegexToken("\\|+"))("disjunction (OR)"),
    implies: /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ unsafeRegexToken("[=-]+>"))("implication"),
    equiv: /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ unsafeRegexToken("(?:=+)|(?:<[=-]+>)|(?:\\^+)"))("equivalence")
};
var operatorTable = /* #__PURE__ */ operatorTable$prime(exprLexemes);
var base64 = /* #__PURE__ */ (function () {
    return Parsing_Combinators.withErrorMessage(applyFirst(termLexemes.base64)(Parsing_Combinators.notFollowedBy(termChar)))("Base64-Term");
})();
var term = /* #__PURE__ */ Parsing_Combinators.withErrorMessage(/* #__PURE__ */ alt(/* #__PURE__ */ Parsing_Combinators["try"](urlSafeBase64))(base64))("Term");
var b4 = /* #__PURE__ */ (function () {
    return alt(voidLeft(unsafeRegex("yes|y|true|t")(Data_String_Regex_Flags.ignoreCase))(Data_LogicValues_B4.Yes.value))(alt(voidLeft(unsafeRegex("no|n|false|f")(Data_String_Regex_Flags.ignoreCase))(Data_LogicValues_B4.No.value))(alt(voidLeft(unsafeRegex("undecidable|u")(Data_String_Regex_Flags.ignoreCase))(Data_LogicValues_B4.Undecidable.value))(Parsing_Combinators.withErrorMessage(voidLeft(unsafeRegex("indeterminate|i")(Data_String_Regex_Flags.ignoreCase))(Data_LogicValues_B4.Indeterminate.value))("B4-Value"))));
})();
var leaf = function (term1) {
    return alt(Parsing_Combinators["try"](map(Data_Either.Left.create)(applyFirst(b4)(Parsing_Combinators.notFollowedBy(termChar)))))(Parsing_Combinators["try"](map(Data_Either.Right.create)(term1)));
};
var expression = function (term1) {
    var go = function (p) {
        return Parsing_Expr.buildExprParser(operatorTable)(alt(parens(p))(map(pure)(leaf(term1))));
    };
    return applyFirst(applyFirst(applySecond(Parsing_String_Basic.skipSpaces)(fix(go)))(Parsing_String_Basic.skipSpaces))(Parsing_String.eof);
};
var parseExpression = function (term1) {
    return function (input) {
        return map1(Data_LogicExpr_AST.ValueExpr)(Parsing.runParser(input)(expression(term1)));
    };
};
var parseExpression$prime = /* #__PURE__ */ parseExpression(term);
var parseExpressionT = function (dictMonadRec) {
    var map2 = Data_Functor.map((((dictMonadRec.Monad0()).Bind1()).Apply0()).Functor0());
    var runParserT = Parsing.runParserT(dictMonadRec);
    return function (term1) {
        return function (input) {
            return map2(map1(Data_LogicExpr_AST.ValueExpr))(runParserT(input)(expression(term1)));
        };
    };
};
var parseExpressionT$prime = function (dictMonadRec) {
    return parseExpressionT(dictMonadRec)(term);
};
var leaf$prime = /* #__PURE__ */ leaf(term);
export {
    b4,
    expression,
    leaf$prime,
    operatorTable,
    parseExpression,
    parseExpression$prime,
    parseExpressionT,
    parseExpressionT$prime
};
//# sourceMappingURL=index.js.map
